import {
  AllegroReturnPolicy,
  AllegroReturnPolicyAvailabilityRange,
  AllegroReturnPolicyRestrictionCauseName,
  AllegroReturnPolicyReturnCostCoveredBy,
} from '../../../../../api/allegro/returnpolicy/returnPolicyTypes';

export interface Edit {
  label: string;
  range: AllegroReturnPolicyAvailabilityRange | null;
  restrictionCauseName: AllegroReturnPolicyRestrictionCauseName | null;
  restrictionCauseDescription: string;
  withdrawalPeriod: string;
  coveredBy: AllegroReturnPolicyReturnCostCoveredBy | null;
  name: string;
  street: string;
  postCode: string;
  city: string;
  countryCode: string | null;
  email: string;
  phoneNumber: string;
  cashOnDeliveryNotAllowed: boolean;
  freeAccessoriesReturnRequired: boolean;
  refundLoweredByReceivedDiscount: boolean;
  businessReturnAllowed: boolean;
  collectBySellerOnly: boolean;
}

export type Status = 'ready' | 'saving';

export interface State {
  status: Status;
  edit: Edit;
}

type EditSetAction = { type: 'edit/set', payload: Edit };
type StatusSetAction = { type: 'status/set', payload: Status };
export type Action = EditSetAction | StatusSetAction;

const initialEdit: Edit = {
  label: '',
  range: null,
  restrictionCauseName: null,
  restrictionCauseDescription: '',
  withdrawalPeriod: '',
  coveredBy: null,
  name: '',
  street: '',
  postCode: '',
  city: '',
  countryCode: null,
  email: '',
  phoneNumber: '',
  cashOnDeliveryNotAllowed: false,
  freeAccessoriesReturnRequired: false,
  refundLoweredByReceivedDiscount: false,
  businessReturnAllowed: false,
  collectBySellerOnly: false,
};

export function getInitialState(returnPolicy?: AllegroReturnPolicy): State {
  if (!returnPolicy) {
    return { status: 'ready', edit: initialEdit };
  }

  const {
    availability, returnCost, address, contact, options,
  } = returnPolicy;
  const { restrictionCause } = availability;

  return {
    status: 'ready',
    edit: {
      label: returnPolicy.name,
      range: availability.range,
      restrictionCauseName: restrictionCause?.name ?? null,
      restrictionCauseDescription: restrictionCause?.description ?? '',
      withdrawalPeriod: returnPolicy.withdrawalPeriod ?? '',
      coveredBy: returnCost?.coveredBy ?? null,
      name: address?.name ?? '',
      street: address?.street ?? '',
      postCode: address?.postCode ?? '',
      city: address?.city ?? '',
      countryCode: address?.countryCode ?? null,
      email: contact?.email ?? '',
      phoneNumber: contact?.phoneNumber ?? '',
      cashOnDeliveryNotAllowed: options?.cashOnDeliveryNotAllowed ?? false,
      freeAccessoriesReturnRequired: options?.freeAccessoriesReturnRequired ?? false,
      refundLoweredByReceivedDiscount: options?.refundLoweredByReceivedDiscount ?? false,
      businessReturnAllowed: options?.businessReturnAllowed ?? false,
      collectBySellerOnly: options?.collectBySellerOnly ?? false,
    },
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'edit/set': {
      const nextEdit = action.payload;

      if (nextEdit.range === state.edit.range) {
        return { ...state, edit: nextEdit };
      }

      return {
        ...state,
        edit: {
          ...initialEdit,
          label: nextEdit.label,
          range: nextEdit.range,
        },
      };
    }
    case 'status/set': {
      return { ...state, status: action.payload };
    }
    default:
      return state;
  }
}
